class EducationDegree {
  constructor(title) {
    this.title = title;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      allEducationDegrees: [],
      allEducationDegreesForOther: [],
      educationDegree: new EducationDegree(''),
    };
  },
  methods: {
    getListOfEducationDegreesForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllEducationDegrees').then(() => {
        if (this.$store.state.educationDegreeModule.successFlag) {
          this.allEducationDegreesForOther =
            this.$store.state.educationDegreeModule.allEducationDegrees;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.educationDegreeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfEducationDegreesForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.educationDegreeModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfEducationDegreesForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllEducationDegrees: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllEducationDegrees').then(() => {
        if (this.$store.state.educationDegreeModule.successFlag) {
          this.allEducationDegrees = this.$store.state.educationDegreeModule.allEducationDegrees;
          this.allEducationDegrees.forEach((c) => (c.isEdit = false));
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.educationDegreeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllEducationDegrees();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.educationDegreeModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllEducationDegrees();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    addEducationDegreeFunction: function () {
      if (!this.educationDegree.title) {
        this.snackText = 'عنوان مدرک تحصیلی نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.educationDegree.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان مدرک تحصیلی نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addEducationDegree', this.educationDegree).then(() => {
        if (this.$store.state.educationDegreeModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.showAddEditModal = false;
          this.disabelConfirm = false;
          this.snackText = ' مدرک تحصیلی با موفقیت اضافه شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.educationDegree = new EducationDegree('');
          this.getAllEducationDegrees();
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.educationDegreeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addEducationDegreeFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.educationDegreeModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addEducationDegreeFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getEducationDegreeFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getEducationDegree', id).then(() => {
        if (this.$store.state.educationDegreeModule.successFlag) {
          this.educationDegree = this.$store.state.educationDegreeModule.educationDegree;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.educationDegreeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getEducationDegreeFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.educationDegreeModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getEducationDegreeFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    editEducationDegreeFunction: function () {
      if (!this.educationDegree.title) {
        this.snackText = 'عنوان مدرک تحصیلی نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.educationDegree.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان مدرک تحصیلی نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('editEducationDegree', this.educationDegree).then(() => {
        if (this.$store.state.educationDegreeModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          this.showAddEditModal = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getAllEducationDegrees();
          this.snackText = ' مدرک تحصیلی با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.educationDegree = new EducationDegree('');
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.educationDegreeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.editEducationDegreeFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.educationDegreeModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.editEducationDegreeFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deleteEducationDegreeFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deleteEducationDegree', this.educationDegreeId).then(() => {
        if (this.$store.state.educationDegreeModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getAllEducationDegrees();
          this.snackText = ' مدرک تحصیلی با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.educationDegreeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deleteEducationDegreeFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.educationDegreeModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deleteEducationDegreeFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.educationDegreeModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
